import { Injectable } from "@angular/core";
import { Keyboard, KeyboardResize, KeyboardStyle } from '@capacitor/keyboard';
import { PlatformService } from "./platform.service";

@Injectable({
    providedIn: 'root'
})
export class KeyboardService {

    constructor(
    ) { }

    /**
     * Initialize Capacitor Keyboard
     */
    public init() {

        if (PlatformService.isBrowser()) return;

        if (PlatformService.isAndroid()) {
            Keyboard.setScroll({ isDisabled: false });
            Keyboard.setResizeMode({ mode: KeyboardResize.Body });
            Keyboard.setStyle({ style: KeyboardStyle.Default });
        }
    }

}